import { InputConfig } from 'features/filters/components/AdaptiveForm/AdaptiveForm.types';

export const TIMELINE_FILTERS = ['severity', 'dt_timestamp', 'msg', 'type'];

export enum TIMELINE_FILTER_KEYS {
  SEVERITY = 'severity__eq',
  MESSAGE = 'msg__contains',
  TYPE = 'type__eq',
  DATE_FROM = 'dt_timestamp__ge',
  DATE_TO = 'dt_timestamp__le',
}

const inputOptionsMap = {
  severity: [
    { label: 'Warning', value: 'warning' },
    { label: 'Info', value: 'info' },
    { label: 'Error', value: 'error' },
  ],
  type: [
    { label: 'Command', value: 'command response' },
    { label: 'Notification', value: 'notification' },
  ],
};

export const createInputConfig = (
  selectedPropertyValue: string,
  t: any
): {
  config: InputConfig;
  TIMELINE_FILTER_LABEL_MAP: Record<string, string>;
} => {
  const TIMELINE_FILTER_LABEL_MAP = {
    [TIMELINE_FILTER_KEYS.SEVERITY]: t('components:timeline.filter.severity'),
    [TIMELINE_FILTER_KEYS.MESSAGE]: t('components:timeline.filter.message'),
    [TIMELINE_FILTER_KEYS.TYPE]: t('components:timeline.filter.type'),
    [TIMELINE_FILTER_KEYS.DATE_FROM]: t('components:timeline.filter.dateFrom'),
    [TIMELINE_FILTER_KEYS.DATE_TO]: t('components:timeline.filter.dateTo'),
  };

  const baseConfig: InputConfig<{ compareFnKey: string }> = [
    {
      name: 'property',
      label: t('components:filters.filterKey'),
      componentType: 'select',
      defaultValue: { label: '', value: '', compareFnKey: '' },
      options: [
        { label: TIMELINE_FILTER_LABEL_MAP[TIMELINE_FILTER_KEYS.SEVERITY], value: 'severity', compareFnKey: 'eq' },
        // { label: TIMELINE_FILTER_LABEL_MAP[TIMELINE_FILTER_KEYS.MESSAGE], value: 'msg', compareFnKey: 'contains' },
        { label: TIMELINE_FILTER_LABEL_MAP[TIMELINE_FILTER_KEYS.TYPE], value: 'type', compareFnKey: 'eq' },
        { label: TIMELINE_FILTER_LABEL_MAP[TIMELINE_FILTER_KEYS.DATE_FROM], value: 'dt_timestamp', compareFnKey: 'ge' },
        { label: TIMELINE_FILTER_LABEL_MAP[TIMELINE_FILTER_KEYS.DATE_TO], value: 'dt_timestamp', compareFnKey: 'le' },
      ],
    },
  ];

  if (selectedPropertyValue === 'severity' || selectedPropertyValue === 'type') {
    baseConfig.push({
      name: 'value',
      label: t('components:filters.filterValue'),
      componentType: 'select',
      defaultValue: { label: '', value: '' },
      // @ts-expect-error: options type is less strict for value field
      options: inputOptionsMap[selectedPropertyValue],
    });
  } else if (selectedPropertyValue === 'msg') {
    baseConfig.push({
      name: 'value',
      label: t('components:filters.filterValue'),
      componentType: 'text',
    });
  } else if (selectedPropertyValue === 'dt_timestamp') {
    baseConfig.push({
      name: 'value',
      label: t('components:filters.filterValue'),
      componentType: 'datepicker',
      maxDate: new Date(),
    });
  }

  return {
    config: baseConfig,
    TIMELINE_FILTER_LABEL_MAP,
  };
};
